import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { LoadDataFacade, SetInitialStateFacade } from '../../../../../common/models';
import { HubListInitialState, HubListLoad } from './hub-list.actions';
import { HubListState, HubListStateModel } from './hub-list.state';
import { HubListSearchCriteria } from '../models';
import { ListSearchCriteriaFacade, ListSearchCriteriaType } from '../../../list-search-criteria';
import { ListQueryParam } from '../../../../../common/constants/list-query-param.constant';

@Injectable({ providedIn: 'root' })
export class HubListFacade implements LoadDataFacade, SetInitialStateFacade {
  listDto$: Observable<HubListStateModel> = this.store.select(HubListState.getState);
  loaded$: Observable<boolean> = this.store.select(HubListState.getLoaded);

  constructor(private store: Store, private listSearchCriteriaFacade: ListSearchCriteriaFacade) {}

  loadAll(): void {
    const hubListSize = 1000;
    this.listSearchCriteriaFacade
      .getSearchCriteriaByListType(ListSearchCriteriaType.Hubs)
      .subscribe((searchCriteria: HubListSearchCriteria) => {
        // Temporary solution to list every assigned hub in location info
        searchCriteria = { ...searchCriteria, [ListQueryParam.Size]: hubListSize };
        this.store.dispatch(new HubListLoad(searchCriteria));
      });
  }

  loadListForDialog(searchCriteria: HubListSearchCriteria): void {
    this.store.dispatch(new HubListLoad(searchCriteria));
  }

  setInitialState(): void {
    this.store.dispatch(new HubListInitialState());
  }
}
